import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import {
  FaqDataModel,
  FaqProductDataModel,
  PaginatedFaqResponse,
} from "../Helpers/Interfaces/FaqType";
import Config from "../Config";

export const faqApi = createApi({
  reducerPath: "faqApi",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["FAQ", "PRODUCT_FAQ"],
  endpoints: (builder) => ({
    getFaqList: builder.query({
      query: () => ({
        url: ApiPath.faqList,
        method: "GET",
      }),
      transformResponse: (response: { data: FaqDataModel[] }) => response.data,
      providesTags: ["FAQ"],
    }),

    getFaqListByPagination: builder.query<
      PaginatedFaqResponse,
      { page: number; pageSize: number }
    >({
      query: ({ page, pageSize }) => ({
        url: `${ApiPath.faqList}?page=${page}&pageSize=${pageSize}`,
        method: "GET",
      }),
      providesTags: ["FAQ"],
    }),

    // 'PRODUCT_FAQ' — returns array of FAQ groups linked to a product
    getProductFaqList: builder.query<FaqProductDataModel[], string>({
      query: (productId: string) => ({
        url: `${ApiPath.faqProductList}${productId ? `/${productId}` : ""}`,
        method: "GET",
      }),
      transformResponse: (response: {
        data: FaqProductDataModel | FaqProductDataModel[];
      }) => {
        // Handle both single object (old) and array (new) response
        if (Array.isArray(response.data)) return response.data;
        if (response.data) return [response.data];
        return [];
      },
      providesTags: ["PRODUCT_FAQ"],
    }),

    getListForProductFaq: builder.query({
      query: ({
        page,
        pageSize,
        faqId,
      }: {
        page: number;
        pageSize: number;
        faqId?: string;
      }) => ({
        url: `${ApiPath.productFaqList}${faqId ? `/${faqId}` : ""}?page=${page}&pageSize=${pageSize}`,
        method: "GET",
      }),
      providesTags: ["PRODUCT_FAQ"],
    }),
  }),
});

export const {
  useGetFaqListQuery,
  useLazyGetFaqListQuery,
  useLazyGetProductFaqListQuery,
  useLazyGetListForProductFaqQuery,
  useGetFaqListByPaginationQuery,
} = faqApi;
